import { render } from "./OfficialCallbackView.vue?vue&type=template&id=77eece2d&scoped=true"
import script from "./OfficialCallbackView.vue?vue&type=script&lang=js"
export * from "./OfficialCallbackView.vue?vue&type=script&lang=js"

import "./OfficialCallbackView.vue?vue&type=style&index=0&id=77eece2d&scoped=true&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77eece2d"]])

export default __exports__